<template>
  <div>
    <nav class="header">
      <div>
        <ul class="flex nav nav-pills">
          <li :class="['nav-item app-logo', 'selected-nav-item']">
            <a href="#studios" id="studios-tab" class="active">
              <img :src="fit20.storageBaseUrl + '/static/images/fit20-logo.png'" />
            </a>
          </li>
        </ul>
      </div>
    </nav>
    <div class="home-page">
      <div class="">
        {{ $t('logout-msg') }}
      </div>
      <div class="login-btn" @click="login"> {{ $t('login') }}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  props: ["fit20"],
  data() {
    return {
    };
  },
  methods: {
    login: function () {
      const logoutWindow = window.open('https://mail.google.com/mail/?logout&hl=en', 'Disconnect from Google', 'width=100,height=50,menubar=no,status=no,location=no,toolbar=no,scrollbars=no,top=200,left=200');
      setTimeout(() => {
        if (logoutWindow && !logoutWindow.closed) {
          logoutWindow.close();
        }
        window.location.href = window.location.origin;
      }, 400);
    }
  },
  created: async function () {
  }
};
</script>
<style>
.home-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
}

.login-btn {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: var(--fit20-blue);
  color: white;
  border-radius: 8px;
  cursor: pointer;
}
</style>
